<template>
  <template v-if="cottages">
    <TContainer :mobile-full="true">
      <UCarousel v-slot="slotData" :items="cottages" :ui="cottageCarousel">
        <CottageSwiperRecommendedCard :item="parseCard(slotData.item)" />
      </UCarousel>
    </TContainer>
  </template>
</template>
<script setup lang="ts">
import { cottageCarousel } from '~~/modules/design-system/utils/nuxt-ui-config/components/carousel'
import type { CottageSwiperRecommended } from '../../entities/CottageSwiperRecommended'
import type { CottageCard } from '../../entities/CottageCard'

interface propsInterface {
  cottages: CottageSwiperRecommended | null
}

defineProps<propsInterface>()

const parseCard = (slide: any): CottageCard => {
  const cottageCard: CottageCard = {
    name: slide.name,
    zone: slide.zone,
    src: slide.src,
    url: slide.url,
    numComments: slide.numComments,
    rate: slide.rate,
  }

  return cottageCard
}
</script>
